// Shared color-picker + hex-input pair, extracted from AdminOrgTheme.jsx (the
// original organisation-level ticket-theme editor) so the per-event ticket-theme
// override editor (AdminEventTicketDesign.jsx) can reuse the exact same control
// rather than duplicating it — both edit fields of the same ticket_theme shape.
export default function ColorField({ label, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">{label}</span>
      <div className="mt-1 flex items-center gap-2">
        <input
          type="color"
          value={value || "#000000"}
          onChange={(e) => onChange(e.target.value)}
          data-testid={`${testid}-picker`}
          className="h-10 w-14 rounded-lg border border-svj-border bg-svj-bg cursor-pointer"
        />
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          data-testid={`${testid}-hex`}
          placeholder="#0f1a2e"
          className="flex-1 h-10 px-3 rounded-lg bg-svj-bg border border-svj-border text-white text-sm font-mono focus:outline-none focus:ring-2 focus:ring-svj-cyan"
        />
      </div>
    </label>
  );
}
